import { Outlet } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import AdminTopBar from "./components/AdminTopBar";

export default function AdminLayout() {
  return (
    <div className='min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 text-white'>
      <AdminTopBar />

      <div className='flex'>
        <Sidebar />

        <main className='flex-1 min-h-screen overflow-y-auto'>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
